import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-[#1a2e44] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="space-y-6">
            <img 
              src="https://customer-assets.emergentagent.com/job_cd4f5c4d-92f8-4312-8a77-df80f7c24853/artifacts/m2jsgssv_grounds%20care%20copy%20.png"
              alt="Sunlight Grounds Care"
              className="h-16 w-auto bg-white p-2 rounded"
            />
            <p className="text-slate-400 text-sm leading-relaxed">
              Structured exterior maintenance programs designed to protect and enhance property value. Serving Los Angeles County and surrounding areas.
            </p>
            <a 
              href="tel:6267372797" 
              className="inline-flex items-center gap-2 text-white font-bold text-lg hover:text-slate-300 transition-colors"
            >
              <Phone className="w-5 h-5" />
              (626) 737-2797
            </a>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-sm font-bold mb-6 uppercase tracking-wider text-white">Navigation</h4>
            <ul className="space-y-3">
              {['Services', 'Industries', 'How We Work', 'About', 'Contact'].map((item) => (
                <li key={item}>
                  <Link 
                    to={`/${item.toLowerCase().replace(/\s+/g, '-')}`}
                    className="text-slate-400 hover:text-white text-sm transition-colors"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-sm font-bold mb-6 uppercase tracking-wider text-white">Services</h4>
            <ul className="space-y-3">
              {[
                { name: 'Landscape Maintenance', link: '/landscape-maintenance' },
                { name: 'Irrigation Management', link: '/irrigation-management' },
                { name: 'Pressure Washing', link: '/pressure-washing' },
                { name: 'Exterior Asset Care', link: '/exterior-asset-care' }
              ].map((service) => (
                <li key={service.name}>
                  <Link 
                    to={service.link}
                    className="text-slate-400 hover:text-white text-sm transition-colors"
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-bold mb-6 uppercase tracking-wider text-white">Contact</h4>
            <ul className="space-y-4">
              <li>
                <a href="tel:6267372797" className="flex items-start gap-3 text-slate-400 hover:text-white text-sm transition-colors">
                  <Phone className="w-4 h-4 mt-0.5" />
                  <span>(626) 737-2797</span>
                </a>
              </li>
              <li>
                <a href="mailto:info@sunlightgroundscare.com" className="flex items-start gap-3 text-slate-400 hover:text-white text-sm transition-colors">
                  <Mail className="w-4 h-4 mt-0.5" />
                  <span>info@sunlightgroundscare.com</span>
                </a>
              </li>
              <li>
                <span className="flex items-start gap-3 text-slate-400 text-sm">
                  <MapPin className="w-4 h-4 mt-0.5" />
                  <span>Pasadena & Los Angeles County</span>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-slate-500 text-sm">
              © {new Date().getFullYear()} Sunlight Grounds Care. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <Link to="/privacy" className="text-slate-500 hover:text-white text-sm transition-colors" data-testid="footer-privacy-link">
                Privacy Policy
              </Link>
              <span className="text-slate-600">|</span>
              <Link to="/terms" className="text-slate-500 hover:text-white text-sm transition-colors" data-testid="footer-terms-link">
                Terms & Conditions
              </Link>
              <span className="text-slate-600">|</span>
              <span className="text-slate-500 text-sm font-medium">
                Licensed & Insured
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
